import { H3, H5, Body2 } from '../../Nodes/Typography'
import { formatDate } from '../../../utilities'

const ArticleList = (props) => {
    return (
        <div className="article_list">
            {props.title && <H3 className="article_list__title" dangerouslySetInnerHTML={{ __html: props.title }} /> }
            {props.image && <div className="article_list__image" style={{ 'backgroundImage': `url('${props.image}')` }}></div>}
            <ul className="article_list__ul">
                {props.articles ? (
                    props.articles.map((article, i) => (
                        <li className="article_list__li"
                            key={'article_list__li--' + i }>
                            <a href={'/article/' + article.id}>
                                <H5>{article.title}</H5>
                                {article.publication_date && (<Body2>{formatDate(article.publication_date)}</Body2>)}
                            </a>
                        </li>
                    ))
                ) : null}
            </ul>
        </div>
    )
}

export default ArticleList